var map = {
	"./discount.svg": 97594,
	"./error-banner.svg": 31958,
	"./location-line.svg": 94217,
	"./meeting-room.svg": 41593,
	"./percentage_symbol.svg": 58642,
	"./success.svg": 12144,
	"./vehicle.svg": 29437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95939;